/**
 * Bootstrap splash shown while the app silently refreshes the session on
 * cold-start. Replaces the brief "login page flicker → redirect home" UX
 * that happens because the access token isn't persisted.
 */
export function SplashScreen() {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1.5rem',
        fontFamily: "'Heebo', 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        zIndex: 9999,
      }}
      role="status"
      aria-label="Loading"
    >
      <div
        style={{
          fontFamily: "'Georgia', serif",
          fontSize: '2.4rem',
          letterSpacing: '-0.5px',
        }}
      >
        <span style={{ fontWeight: 700, color: '#005bc0' }}>Lot</span>
        <span style={{ fontWeight: 400, color: '#005bc0' }}>'N'Go</span>
      </div>
      <div
        style={{
          width: 36,
          height: 36,
          border: '3px solid #d6e4ff',
          borderTopColor: '#005bc0',
          borderRadius: '50%',
          animation: 'lotngoSpin 0.9s linear infinite',
        }}
      />
      <style>{`
        @keyframes lotngoSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
